<div class="sh-upload-panel -sh-is-raised" [ngClass]="!disabled && enableFileUpload ? '' : '-sh-no-border'">
  @if (imageSrc) {
    <img class="sh-upload-panel__figure" src="{{ imageSrc }}" alt="{{ imageAlt }}" role="presentation" aria-hidden="true" />
  }
  @if (title) {
    <h2 class="sh-upload-panel__title">{{ title }}</h2>
  }

  @if (!disabled) {
    @if (message) {
      <p class="sh-upload-panel__message">{{ message }}</p>
    }
    <button class="sh-upload-panel__controls sh-button sh-icon-button" for="file-upload" (keydown.enter)="onButtonClicked()">
      @if (buttonIcon) {
        <svg sh-icon [name]="buttonIcon" [size]="iconSize" aria-hidden="true" class="sh-icon-button__icon"></svg>
      }
      {{ buttonText }}
      <input
        (click)="onButtonClicked()"
        (keydown.enter)="onButtonClicked()"
        (change)="fileInputChange($event)"
        class="sh-upload-panel__controls__hidden-control"
        id="file-upload"
        [type]="enableFileUpload ? 'file' : 'submit'"
        name="file-upload"
        [multiple]="multiple"
        />
    </button>
  }
</div>
